module.exports = __webpack_public_path__ + "static/media/immigrants.0a259973.jpg";